export const httpConstants = {
    translationGroup: "_http"
}